import { DialogActions, DialogContent, DialogTitle } from "@mui/material"
import PropTypes from "prop-types"
import React, { Fragment } from "react"
import { UiCtButton } from "../MuiStyled/LibComponent"
import { UiTextWrapper } from "../MuiStyled/Text"

function CtAlertModal({ title, message, actionButtons }) {
  return (
    <Fragment>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <UiTextWrapper>{message}</UiTextWrapper>
      </DialogContent>
      <DialogActions>
        {actionButtons.map((button, btnIndex) => (
          <UiCtButton
            key={`alert-modal-${btnIndex}`}
            variant={["CLOSE", "CANCEL"].includes(button.type) ? "outlined" : "contained"}
            type={button.type}
            className={`${button.classNames.join(" ")}`}
            onClick={button.clickHandler}
          >
            {button.text}
          </UiCtButton>
        ))}
      </DialogActions>
    </Fragment>
  )
}

CtAlertModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  actionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      type: PropTypes.string,
      classNames: PropTypes.array,
      clickHandler: PropTypes.func,
    })
  ),
}

export default CtAlertModal
